//Infrastructure / Supabase adapter

import { supabase } from '../../../infra_/supabase/supabaseClient.js'

export async function obtenerPeriodoAbierto() {
  const { data, error } = await supabase
    .from("periodos_inventario")
    .select("*")
    .eq("estado", "abierto")
    .maybeSingle();

  if (error) throw error;

  return data;
}


export async function obtenerPeriodoPorFecha(fecha) {
  const { data, error } = await supabase
    .from("periodos_inventario")
    .select("*")
    .lte("fecha_inicio", fecha)
    .gte("fecha_fin", fecha)
    .maybeSingle();

  if (error) throw error;

  return data;
}

export async function listarPeriodos() {
  const { data, error } = await supabase
    .from("periodos_inventario")
    .select("*")
    .order("anio", { ascending: false })
    .order("mes", { ascending: true });

  if (error) throw error;

  return data;
}

export async function modificarPeriodosInventario({ periodoId, estado }) {
  const { data, error } = await supabase
    .from("periodos_inventario")
    .update({ estado })
    .eq("id", periodoId)

    .select("*")
    .maybeSingle();
    if (error) throw error;

  return data;
}
